module.exports = __webpack_public_path__ + "static/img/Harris-Andrews.34d205b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Harris-Andrews.jpg
// module id = 8lb0
// module chunks = 0